import { ANDROID_PACKAGE, APP_LINK, APP_ONE_LINK, DEEP_LINK } from '../enum/Constants';
import { parseQueryString } from '../util/common';
import { firebaseInit } from './firebase';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
var goLink = function (type, contentsId) {
    var PID = parseQueryString().pid;
    var C = 'Aug2021';
    var baseLink = "".concat(APP_ONE_LINK, "?pid=").concat(PID, "&c=").concat(C, "&is_retargeting=true");
    var infoLink = 'https://forms.gle/JmysajQUSsXWWo8k7';
    var link = '';
    if (type === 'join') {
        link = "".concat(baseLink, "&af_ios_url=").concat(APP_LINK, "/my&af_android_url=").concat(DEEP_LINK, "/mkmy");
    }
    else if (type === 'contents') {
        link =
            "".concat(baseLink, "&af_ios_url=").concat(APP_LINK, "/video/").concat(contentsId, "?isDeep") +
                "&af_android_url=".concat(DEEP_LINK, "/?link=").concat(APP_LINK, "/video/").concat(contentsId, "?&apn=").concat(ANDROID_PACKAGE);
    }
    else {
        link = infoLink;
    }
    window.open(link, '_self');
};
var initialize = function () {
    firebaseInit();
    var joinBtn = document.getElementById('join-button');
    var contentsBtn1 = document.getElementById('contents-button-1');
    var contentsBtn2 = document.getElementById('contents-button-2');
    var infoBtn = document.getElementById('info-button');
    if (joinBtn && contentsBtn1 && contentsBtn2 && infoBtn) {
        joinBtn.addEventListener('click', function () { return goLink('join'); });
        contentsBtn1.addEventListener('click', function () { return goLink('contents', 189137); });
        contentsBtn2.addEventListener('click', function () { return goLink('contents', 189139); });
        infoBtn.addEventListener('click', function () { return goLink('info'); });
    }
};
initialize();
